/* eslint-disable no-undef */
import qs from 'query-string';
import useBaseAPI from './useBaseAPI';

const useWidgetAPI = () => {
  const { client, isLoading } = useBaseAPI();

  const getDropDownOptions = async () => {
    try {
      const response = await client('get', `/v1/widget/customer/projects`, null, {
        baseUrl: process.env.REACT_APP_WIDGET_ENDPOINT,
        withCredentials: false,
      });
      return response?.data;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const getMonthlyInvoiceData = async (query) => {
    try {
      const response = await client(
        'get',
        `/v1/widget/monthly-invoice/?${qs.stringify(query)}`,
        null,
        {
          baseUrl: process.env.REACT_APP_WIDGET_ENDPOINT,
          withCredentials: false,
        },
      );
      return response?.data;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const getRecentInvoiceData = async (query) => {
    try {
      const response = await client(
        'get',
        `/v1/widget/recent-invoice/?${qs.stringify(query)}`,
        null,
        {
          baseUrl: process.env.REACT_APP_WIDGET_ENDPOINT,
          withCredentials: false,
        },
      );
      return response?.data;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const getDeliveredAndScheduleData = async (query) => {
    try {
      const response = await client('get', `/v1/widget/calender/?${qs.stringify(query)}`, null, {
        baseUrl: process.env.REACT_APP_WIDGET_ENDPOINT,
        withCredentials: false,
      });
      return response?.data;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const getConsumptionsData = async (query) => {
    try {
      const response = await client('get', `/v1/widget/consumption/?${qs.stringify(query)}`, null, {
        baseUrl: process.env.REACT_APP_WIDGET_ENDPOINT,
        withCredentials: false,
      });
      return response?.data;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const saveWidget = async (widgets) => {
    try {
      const response = await client('post', `/usersetting`, widgets);
      return response;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const getWidgets = async () => {
    try {
      const response = await client('get', `/usersetting/key/selectedWidgets`, null);
      return response;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  return {
    getDropDownOptions,
    getMonthlyInvoiceData,
    getRecentInvoiceData,
    getDeliveredAndScheduleData,
    getConsumptionsData,
    saveWidget,
    getWidgets,
    isLoading,
  };
};

export default useWidgetAPI;
